'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onEmbedSave", "onEmbedRemove"];
import PropTypes from 'prop-types';
import { PopoverBodyMode } from '../../constants/popover';
import EmbedPopoverBodyLite from './EmbedPopoverBodyLite';
import EmbedPopoverBodyEdit from './EmbedPopoverBodyEdit';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onEmbedSave: PropTypes.func.isRequired,
  onEmbedRemove: PropTypes.func.isRequired
};
const defaultProps = {
  mode: PopoverBodyMode.PREVIEW
};
function EmbedPopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onEmbedSave,
      onEmbedRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (mode === PopoverBodyMode.PREVIEW) {
    const handleEdit = () => {
      onModeChange(PopoverBodyMode.EDIT);
    };
    return /*#__PURE__*/_jsx(EmbedPopoverBodyLite, {
      onEdit: handleEdit,
      onRemove: onEmbedRemove
    });
  }
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  return /*#__PURE__*/_jsx(EmbedPopoverBodyEdit, Object.assign({}, rest, {
    onSubmit: onEmbedSave,
    onClose: handleClose
  }));
}
EmbedPopoverBodyBranch.propTypes = propTypes;
EmbedPopoverBodyBranch.defaultProps = defaultProps;
export default EmbedPopoverBodyBranch;